import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useUiStore = create(
  persist(
    (set) => ({
      navOpen: false,
      setNavOpen: (open) => set({ navOpen: open }),

      // Theme mode: 'light' | 'dark' | 'system'
      themeMode: 'system',
      setThemeMode: (mode) => set({ themeMode: mode }),

      // Backend connectivity
      backendStatus: 'connected', // 'connected' | 'unreachable'
      backendStatusMessage: '',
      setBackendStatus: (status, message) =>
        set({ backendStatus: status, backendStatusMessage: message || '' }),
      clearBackendError: () =>
        set({ backendStatus: 'connected', backendStatusMessage: '' }),

      // Notification tracking
      lastSeenOrderTimestamp: null,
      markOrdersSeen: () => set({ lastSeenOrderTimestamp: new Date().toISOString() }),
    }),
    {
      name: 'ui-preferences',
      partialize: (state) => ({
        themeMode: state.themeMode,
        lastSeenOrderTimestamp: state.lastSeenOrderTimestamp,
      }),
    },
  ),
);

export default useUiStore;
